import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { MuteAction } from "@faire/retailer-visitor-shared/features/InsightsFeed/events";
import { Button } from "@faire/web--source/slate/Button";
import { Modal } from "@faire/web--source/slate/deprecated/Modal";
import { Announcement, AnnouncementMuted } from "@faire/web--source/slate/icons/foundation/Announcement";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { createToast } from "@faire/web--source/slate/Toast/Toast";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { route as getInsightsPreferencesRoute } from "@faire/web-api--source/api/insights/preferences/brandToken/get";
import postMuteStatus from "@faire/web-api--source/api/insights/preferences/brandToken/post";
import { trackMyBrandsMuteInsightsButtonClick } from "@faire/web-api--source/events/myBrands/click/muteInsightsButton";
import { trackMyBrandsMuteInsightsModalView } from "@faire/web-api--source/events/myBrands/view/muteInsightsModal";
import { IRetailerBrandInsightPreference } from "@faire/web-api--source/indigofair/retailer/IRetailerBrandInsightPreference";
import { IRetailerBrandInsightPreferenceRequest } from "@faire/web-api--source/indigofair/retailer/IRetailerBrandInsightPreferenceRequest";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";
import styled from "styled-components";
export var MuteModal = function(param) {
    var brandName = param.brandName, brandToken = param.brandToken, isMuted = param.isMuted, onClose = param.onClose, containerOrigin = param.containerOrigin, onChangeMute = param.onChangeMute;
    var queryClient = useQueryClient();
    var muteStatusMutation = useMutation({
        mutationFn: function(requestParams) {
            return postMuteStatus(brandToken, requestParams);
        },
        onSuccess: function(data) {
            queryClient.setQueryData([
                getInsightsPreferencesRoute,
                brandToken
            ], data);
            onChangeMute === null || onChangeMute === void 0 ? void 0 : onChangeMute(brandToken);
            trackMyBrandsMuteInsightsButtonClick(containerOrigin, isMuted ? MuteAction.Unmute : MuteAction.Mute, brandToken);
            createToast(isMuted ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "rEAuUv",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Updates unmuted"
                    }
                ]
            }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "NwBKrQ",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Updates muted"
                    }
                ]
            }), {
                icon: isMuted ? "foundation:Announcement" : "foundation:AnnouncementMuted",
                timeout: "short"
            });
            onClose();
        }
    });
    React.useEffect(function() {
        trackMyBrandsMuteInsightsModalView(containerOrigin, brandToken);
    }, [
        containerOrigin,
        brandToken
    ]);
    var handleMute = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var insightPreference, insightPreferenceRequestData;
            return _ts_generator(this, function(_state) {
                insightPreference = IRetailerBrandInsightPreference.build({
                    brand_token: brandToken,
                    is_muted: !isMuted
                });
                insightPreferenceRequestData = IRetailerBrandInsightPreferenceRequest.build({
                    retailer_brand_insight_preference: insightPreference
                });
                muteStatusMutation.reset();
                muteStatusMutation.mutate(insightPreferenceRequestData);
                return [
                    2
                ];
            });
        });
        return function handleMute() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDismiss = function() {
        trackMyBrandsMuteInsightsButtonClick(containerOrigin, MuteAction.Dismiss, brandToken);
        onClose();
    };
    return /*#__PURE__*/ _jsx(Modal, {
        height: "auto",
        padding: "24px",
        onClose: handleDismiss,
        children: /*#__PURE__*/ _jsxs(Column, {
            children: [
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "8x"
                }),
                /*#__PURE__*/ _jsx(IconWrapper, {
                    children: isMuted ? /*#__PURE__*/ _jsx(Announcement, {
                        fontSize: "24px"
                    }) : /*#__PURE__*/ _jsx(AnnouncementMuted, {
                        fontSize: "24px"
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "4x"
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "displaySSerifRegular",
                    children: isMuted ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "7VUnJj",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Unmute updates from "
                            },
                            {
                                type: 1,
                                value: "brandProductName"
                            },
                            {
                                type: 0,
                                value: "?"
                            }
                        ],
                        values: {
                            brandProductName: brandName
                        }
                    }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "ITocjf",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Mute updates from "
                            },
                            {
                                type: 1,
                                value: "brandProductName"
                            },
                            {
                                type: 0,
                                value: "?"
                            }
                        ],
                        values: {
                            brandProductName: brandName
                        }
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "4x"
                }),
                isMuted ? /*#__PURE__*/ _jsx(Typography, {
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "QvspLl",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Get updates when this brand has new products, promotions, and more."
                            }
                        ]
                    })
                }) : /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "R21Tlr",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "You\u2019ll no longer get updates when this brand has new products, promotions, and more."
                                    }
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            height: "2x"
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "FaYLC1",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "To get these updates again, unmute updates on their brand page."
                                    }
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "4x"
                }),
                /*#__PURE__*/ _jsx(Button, {
                    variant: "primary",
                    onClick: handleMute,
                    loading: muteStatusMutation.isPending,
                    "data-test-id": "MuteModalButton",
                    children: isMuted ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "yFOhnN",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Unmute updates"
                            }
                        ]
                    }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "WdKrem",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Mute updates"
                            }
                        ]
                    })
                }),
                muteStatusMutation.isError ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Spacer, {
                            height: "1x"
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            color: Decorative.shade.orange,
                            align: "center",
                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "a5o2rT",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Something went wrong, please try again"
                                    }
                                ]
                            })
                        })
                    ]
                }) : null,
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "2x"
                }),
                /*#__PURE__*/ _jsx(Button, {
                    variant: "tertiary",
                    onClick: handleDismiss,
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "47FYwb",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Cancel"
                            }
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "2x"
                })
            ]
        })
    });
};
var IconWrapper = styled.div.withConfig({
    componentId: "sc-b9867a6-0"
})([
    "width:72px;height:72px;border-radius:50%;background-color:",
    ";display:flex;align-items:center;justify-content:center;"
], Core.surface.subdued);
